import React from 'react';
import { History } from 'history';
import { Input, InputEmail, InputPassword } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './user-model';  //editable..
import PersonalinfoCreate from '../personalinfo/personalinfo-create.component';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    onSave?: (data: any) => void;
    disableAutoBack?: boolean;
    disableBackButton?: boolean;
    disableCard?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowPersonalinfo: any,
    save: boolean;
}

export default class UserAuthSignup extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowPersonalinfo: null,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onSave = async (data: any) => {
        if (data.id) {
            await Model.setUser(data.id, data.name, data.imageUrl, data.token);
            await this.setState({datarowPersonalinfo: {user: data.id, name: data.name, description: data.name, email: data.useremail}, save: true});
        }
        this.props.onSave?.(data);
    }
    
    private onSavePersonalinfo = async(data: any) => {
        if (data.id) await Model.setUserPersonalinfo(data.id, data.name);
        this.setState({save: false});
    }

    private onChange(fieldName: string, value?: string) { 
        var username = this.state.datarow.username;
        var email = this.state.datarow.email;
        if (fieldName === 'useremail' && value) {
            email = Model.getEmailApp(value);
            username = email;
        }

        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, email: email, username: username,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <>          
            <BaseCreate history={this.props.history} caption={this.props.caption || Model.caption + ' Signup'} buttonCaption='Signup' successCaption='Signed up'
                endPoint={Model.endPointAuth + '/local/register'} model={Model} url={this.props.root} datarow={this.state.datarow} onError={this.onError} buttonOnBottom onSave={this.onSave} disableBackButton={this.props.disableBackButton} disableAutoBack={this.props.disableAutoBack} disableCard={this.props.disableCard}>              
                <Input name='name' label='User Name' value={this.state.datarow.name} error={this.state.errors?.name || this.state.errors?.[0]} onChange={this.onChange} />
                <InputEmail name='useremail' label='Email' value={this.state.datarow.useremail} error={this.state.errors?.useremail} onChange={this.onChange} />
                <InputPassword name='password' label='Password' value={this.state.datarow.password} error={this.state.errors?.password} onChange={this.onChange} />
            </BaseCreate>

            <PersonalinfoCreate history={this.props.history} personalinfotypeType='customer' datarow={this.state.datarowPersonalinfo} onError={this.onError} save={this.state.save} onSave={this.onSavePersonalinfo} disableView />                            
            </>
        );
    }     
     
}